import React from 'react';
import type { ImageProps } from 'next/image';
import Image from 'next/image';

/*
 * Use unoptimized for gifs, to avoid gif images rendering with width and height of 0px
 */
export const NextFutureImage = React.memo(function NextImage(props: ImageProps) {
  const [didError, setDidError] = React.useState(false);
  const { unoptimized, width, sizes } = props;

  // A string providing information on how wide the image should be at different breakpoints.
  // This is used when employing the responsive or fill layout as explained earlier
  const imgSizes = sizes ? sizes : typeof width === 'number' ? `${width}px` : width;

  const onError = React.useCallback(() => setDidError(true), [setDidError]);

  if (didError && !unoptimized) {
    return <NextImage {...props} unoptimized />;
  }

  return (
    <Image
      {...props}
      alt={props.alt}
      unoptimized={unoptimized}
      sizes={unoptimized ? undefined : imgSizes}
      onError={onError}
      onErrorCapture={onError}
    />
  );
});
